import DashboardWithdrawForm from './components/dashboard-withdraw-form/DashboardWithdrawForm';
import './DashboardWithdraw.less';

const DashboardWithdraw = () => {
    return (
        <div className="dashboard-withdraw-container">
            <div className='dashboard-withdraw-content'>
                <DashboardWithdrawForm />
            </div>
        </div>
    )
}

export default DashboardWithdraw;